var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUnion = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 74,
  height: 174,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M59.184 66.366c8.931-6.733 14.706-17.43 14.706-29.477C73.89 16.516 57.373 0 37 0S.11 16.516.11 36.89c0 12.046 5.775 22.743 14.706 29.476L.213 173.24h73.574L59.184 66.366Z",
  fill: "#000"
})));
export default SvgUnion;